import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from ".";
import Label from "components/label/Label";
import TextArea from "components/input/TextArea";
import Button from "components/button/Button";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  handler: () => void;
  loading?: boolean;
  title: string;
  desc?: string;
  primary?: boolean;
  reason?: {
    reason: string;
    setReason: React.Dispatch<React.SetStateAction<string>>;
  };
  primaryText?: string;
  secondaryText?: string;
  error?: boolean;
};

const ConfirmModal = ({
  isOpen,
  onClose,
  handler,
  loading,
  title,
  desc,
  primary = false,
  reason,
  primaryText,
  secondaryText,
  error,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={true}
      className="max-w-[450px] p-6 lg:p-10"
    >
      <div className="text-center">
        <h4
          className={`mb-5 text-lg font-semibold md:text-xl ${
            error
              ? "text-red-700 dark:text-red-300"
              : "text-gray-800 dark:text-white/90"
          }`}
        >
          {title}
        </h4>
        {desc && (
          <p
            className={`sm:text-md text-sm leading-6 ${
              error
                ? "text-red-700 dark:text-red-200"
                : "text-gray-700 dark:text-gray-400"
            }`}
          >
            {desc}
          </p>
        )}

        {reason && (
          <div className="my-4">
            <Label>{t("actions.reason")}</Label>
            <TextArea
              value={reason.reason}
              onChange={(value) => reason.setReason(value)}
              rows={3}
            />
          </div>
        )}

        <div className="mt-8 flex w-full items-center justify-center gap-3">
          <Button size="sm" variant="outline" onClick={onClose}>
            {secondaryText ?? t("buttons.cancel")}
          </Button>
          <Button
            size="sm"
            variant={primary ? "primary" : "error"}
            onClick={handler}
            loading={loading}
          >
            {primaryText ?? t("buttons.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
